import {
	mapActions,
	mapGetters
} from 'vuex';

import PageBar from '@/components/page-bar/page-bar';

export default {
	name: 'dashboard',
	components: {
		PageBar
	},
	data: () => ({
		userId: 1
	}),
	methods: {
		...mapActions([
			'setBreadcrumb',
			'putUserId'
		]),
		updateUserId() {
			return this.putUserId(parseInt(this.userId));
		}
	},
	computed: {
		...mapGetters([
			'getLoggedUser'
		])
	},
	mounted() {

		this.setBreadcrumb([{
			text: 'Dashboard'
		}]);

		this.userId = this.getLoggedUser.id;

	}
};



// WEBPACK FOOTER //
// ./sources/app/dashboard/index.js